import React, { Component } from "react";
import { ADMIN, DESCRIPTION_EXPANDED_KEY, SURVEY_KEY_EDITOR } from "../../../../common/constant";
import {
  EVALUATE_SINCE_FUNDING_STARTED,
  FIELD_REQUIRED,
  LOAD_PREVIOUS_DATA_ENABLED,
  UPLOAD_ENABLED
} from "../../../../ducks/surveyEditor";

import { faEdit, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import { Button, FormControl, FormGroup, FormLabel } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import { FormattedMessage } from "react-intl";
import Checkbox from "../../../common/Checkbox";
import Radio from "../../../common/Radio";
import Visibility from "../../../common/VisibleContainer";
import RichTextEditor from "../../../common/richTextEditor/RichTextEditor";
import InfoTooltip from "../../surveyView/questions/renderer/InfoTooltip";

/**
 * Component which displays question title and question description.
 */
export default class QuestionHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      questionKey: props.question.key
    };
  }

  handleChange(e) {
    const { pageName, question, changeQuestionField } = this.props;
    changeQuestionField(pageName, question.name, e.target.name, e.target.value);
    return e.target.value;
  }

  handleChangeOfCheckbox(e) {
    const { pageName, question, changeQuestionField } = this.props;
    changeQuestionField(pageName, question.name, e.target.name, e.target.checked);
  }

  handleChangeType(e) {
    const { pageName, question, changeQuestionField, loadPredefinedList, addQuestionChoice } = this.props;
    changeQuestionField(pageName, question.name, "type", e.target.value);
    if (e.target.value === "predefinedList") {
      loadPredefinedList(pageName, question.name, "type", "countries");
    } else if (
      (question.type === "predefinedList" && e.target.value === "radio") ||
      (question.type === "predefinedList" && e.target.value === "dropdown")
    ) {
      addQuestionChoice(pageName, question.name, "choices", true);
    }
  }

  render() {
    const { pageName, changeQuestionField, question, children, intl, libraryQuestion } = this.props;
    let questionDescription = question.description ? question.description !== "<p></p>" : false;
    let showDescription = question.descriptionExpanded ? question.descriptionExpanded : questionDescription;
    let event = { target: { name: "title" } };

    return (
      <>
        <h6>
          <FormattedMessage id="survey.editor.question" />
        </h6>
        <FormGroup  className="mb-3">
          <RichTextEditor
            short
            htmlContent={question.title}
            onTextChange={(text) => {
              event.target.value = text;
              this.handleChange(event);
            }}
          />
        </FormGroup>
        <h6>
          <FormattedMessage id="survey.editor.question.configuration" />
        </h6>
        <Container fluid className="mb-3 px-3 pt-4 pb-2 border bg-white border">
          {question.type !== "infoMessage" && (
            <>
              <FormGroup  className="mb-3">
                <Checkbox
                  inline
                  name={[FIELD_REQUIRED]}
                  checked={question[FIELD_REQUIRED]}
                  onChange={(e) => this.handleChangeOfCheckbox(e)}
                >
                  <FormattedMessage id="survey.editor.required" />
                </Checkbox>
                <InfoTooltip infoText={intl.formatMessage({ id: "survey.editor.required.info" })} />
                <Checkbox
                  className="ms-3"
                  inline
                  disabled={
                    question.libraryQuestionId &&
                    question[EVALUATE_SINCE_FUNDING_STARTED] &&
                    libraryQuestion &&
                    libraryQuestion.question &&
                    libraryQuestion.question[EVALUATE_SINCE_FUNDING_STARTED]
                  }
                  name={[EVALUATE_SINCE_FUNDING_STARTED]}
                  checked={question[EVALUATE_SINCE_FUNDING_STARTED]}
                  onChange={(e) => this.handleChangeOfCheckbox(e)}
                >
                  <FormattedMessage id="survey.editor.evaluate.since.funding.started" />
                </Checkbox>
                <InfoTooltip
                  infoText={intl.formatMessage({ id: "survey.editor.evaluate.since.funding.started.info" })}
                />
                <Checkbox
                  className="ms-3"
                  inline
                  name={[LOAD_PREVIOUS_DATA_ENABLED]}
                  checked={question[LOAD_PREVIOUS_DATA_ENABLED]}
                  onChange={(e) => this.handleChangeOfCheckbox(e)}
                >
                  <FormattedMessage id="survey.editor.load.previous.data.enabled" />
                </Checkbox>
                <InfoTooltip infoText={intl.formatMessage({ id: "survey.editor.load.previous.data.enabled.info" })} />
              </FormGroup>
              <FormGroup className="d-flex flex-center align-items-center gap-lg mb-3">
                <FormLabel className="m-0">
                  <FormattedMessage id="survey.editor.question.key" />
                </FormLabel>
                <FormControl
                  className={"d-inline-flex text-long"}
                  size="sm"
                  type="text"
                  readOnly={!this.state.showQuestionKey}
                  name={`${question.key}-key`}
                  value={question.key}
                  onChange={(e) => {
                    this.setState({ questionKey: e.target.value });
                    changeQuestionField(pageName, question.name, "key", e.target.value);
                  }}
                />
                <Visibility roles={[ADMIN, SURVEY_KEY_EDITOR]}>
                  <Button
                    size="sm"
                    variant="link"
                    inline
                    onClick={() => this.setState({ showQuestionKey: !this.state.showQuestionKey })}
                  >
                    <FontAwesomeIcon icon={this.state.showQuestionKey ? faTimes : faEdit} />
                  </Button>
                </Visibility>
              </FormGroup>
              {question.indicators && question.indicators.length > 0 && (
                <div className="jumbotron jumbotron-fluid">
                  <p>
                    <FormattedMessage id="survey.editor.question.linked.indicators" />
                  </p>
                  {question.indicators.map((ind) => (
                    <p key={ind.identifier}>- {`${ind.name[intl.locale]} (${ind.indicatorId})`}</p>
                  ))}
                </div>
              )}
            </>
          )}
          {(question.type === "radio" || question.type === "dropdown" || question.type === "predefinedList") && (
            <FormGroup className="mb-3" controlId="listType">
              <Radio
                name="listType"
                inline
                value="radio"
                checked={question.type === "radio"}
                onChange={(e) => this.handleChangeType(e)}
              >
                <FormattedMessage id="survey.editor.toolbox.radioButton" />
              </Radio>
              <Radio
                name="listType"
                inline
                value="dropdown"
                checked={question.type === "dropdown"}
                onChange={(e) => this.handleChangeType(e)}
              >
                <FormattedMessage id="survey.editor.toolbox.dropdown" />
              </Radio>
              <Radio
                name="listType"
                inline
                value="predefinedList"
                checked={question.type === "predefinedList"}
                onChange={(e) => this.handleChangeType(e)}
              >
                <FormattedMessage id="survey.editor.toolbox.predefinedList" />{" "}
                <InfoTooltip infoText={intl.formatMessage({ id: "survey.editor.toolbox.predefinedList.info" })} />
              </Radio>
            </FormGroup>
          )}
          {(question.type === "matrixSingleChoice" || question.type === "matrixMultipleChoice") && (
            <FormGroup className="mb-3" controlId="matrixType">
              <Radio
                inline
                name="matrixType"
                value="matrixSingleChoice"
                checked={question.type === "matrixSingleChoice"}
                onChange={(e) => this.handleChangeType(e)}
              >
                <FormattedMessage id="survey.editor.toolbox.matrixSingleChoice" />
              </Radio>
              <Radio
                inline
                name="matrixType"
                value="matrixMultipleChoice"
                checked={question.type === "matrixMultipleChoice"}
                onChange={(e) => this.handleChangeType(e)}
              >
                <FormattedMessage id="survey.editor.toolbox.matrixMultipleChoice" />
              </Radio>
            </FormGroup>
          )}
          {(question.type === "staticTable" || question.type === "dynamicTable") && (
            <FormGroup  className="mb-3">
              <Radio
                name="tableType"
                inline
                value="staticTable"
                checked={question.type === "staticTable"}
                onChange={(e) => this.handleChangeType(e)}
              >
                <FormattedMessage id="survey.editor.toolbox.staticTable" />
              </Radio>
              <Radio
                name="tableType"
                inline
                value="dynamicTable"
                checked={question.type === "dynamicTable"}
                onChange={(e) => this.handleChangeType(e)}
              >
                <FormattedMessage id="survey.editor.toolbox.dynamicTable" />
              </Radio>
              {question.type === "dynamicTable" && (
                <Checkbox
                  inline
                  name={[UPLOAD_ENABLED]}
                  checked={question[UPLOAD_ENABLED]}
                  onChange={(e) => this.handleChangeOfCheckbox(e)}
                >
                  <FormattedMessage id="survey.editor.upload.csv.enabled" />
                </Checkbox>
              )}
            </FormGroup>
          )}
          <FormGroup  className="mb-3">
            <Checkbox
              className={"mb-2"}
              name={DESCRIPTION_EXPANDED_KEY}
              checked={showDescription}
              onChange={(e) => this.handleChangeOfCheckbox(e)}
              inline
            >
              <FormattedMessage id="survey.editor.description" />
            </Checkbox>
            {showDescription && (
              <Description changeQuestionField={changeQuestionField} pageName={pageName} question={question} />
            )}
          </FormGroup>
        </Container>
        {children}
      </>
    );
  }
}

class Description extends QuestionHeader {
  render() {
    let questionDescription = this.props.question.description ? this.props.question.description : "<p></p>";
    let event = { target: { name: "description" } };
    return (
      <RichTextEditor
        short
        htmlContent={questionDescription}
        onTextChange={(text) => {
          event.target.value = text;
          super.handleChange(event);
        }}
      />
    );
  }
}

QuestionHeader.propTypes = {
  changeQuestionField: PropTypes.func,
  addIndicatorToQuestion: PropTypes.func,
  removeIndicatorFromQuestion: PropTypes.func,
  loadPredefinedList: PropTypes.func,
  addQuestionChoice: PropTypes.func,
  allIndicators: PropTypes.array,
  pageName: PropTypes.string,
  question: PropTypes.object,
  intl: PropTypes.object,
  locale: PropTypes.string,
  libraryQuestion: PropTypes.object
};
